import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';

// Common domain typos to detect accidental errors
const TYPO_PATTERNS: { pattern: RegExp, suggestion: string }[] = [
  { pattern: /gmail\.co$/i, suggestion: 'gmail.com' },
  { pattern: /gmail\.cm$/i, suggestion: 'gmail.com' },
  { pattern: /gmail\.con$/i, suggestion: 'gmail.com' },
  { pattern: /gmial\.com$/i, suggestion: 'gmail.com' },
  { pattern: /gmal\.com$/i, suggestion: 'gmail.com' },
  { pattern: /yahooo\.com$/i, suggestion: 'yahoo.com' },
  { pattern: /yaho\.com$/i, suggestion: 'yahoo.com' },
  { pattern: /yahoo\.co$/i, suggestion: 'yahoo.com' },
  { pattern: /hotmal\.com$/i, suggestion: 'hotmail.com' },
  { pattern: /hotmial\.com$/i, suggestion: 'hotmail.com' },
  { pattern: /hotmail\.co$/i, suggestion: 'hotmail.com' },
  { pattern: /outlok\.com$/i, suggestion: 'outlook.com' },
  { pattern: /outloo\.com$/i, suggestion: 'outlook.com' },
  { pattern: /outlook\.co$/i, suggestion: 'outlook.com' },
  { pattern: /icoud\.com$/i, suggestion: 'icloud.com' },
  { pattern: /icloud\.co$/i, suggestion: 'icloud.com' },
  { pattern: /aol\.co$/i, suggestion: 'aol.com' }
];

@Component({
  selector: 'app-hospital-group-email-dialog',
  templateUrl: './hospital-group-email-dialog.component.html',
  styleUrls: ['./hospital-group-email-dialog.component.scss'],
  standalone: false
})
export class HospitalGroupEmailDialogComponent {

  // Dialog states: 'initial' | 'emailInput' | 'confirm'
  currentState: string = 'initial';

  emailControl = new FormControl('', [Validators.required, Validators.email]);
  domainError: string = '';
  enteredEmail: string = '';

  constructor(
    public dialogRef: MatDialogRef<HospitalGroupEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onYes(): void {
    this.currentState = 'emailInput';
    this.emailControl.reset();
    this.domainError = '';
  }

  onNo(): void {
    this.dialogRef.close({ action: 'no' });
  }

  onSkip(): void {
    this.dialogRef.close({ action: 'skip' });
  }

  onSubmitEmail(): void {
    this.domainError = '';

    if (this.emailControl.invalid) {
      this.emailControl.markAsTouched();
      return;
    }

    const email = this.emailControl.value!.trim().toLowerCase();

    // Check for domain typos
    const domain = email.split('@')[1];
    if (domain) {
      for (const { pattern } of TYPO_PATTERNS) {
        if (pattern.test(domain)) {
          this.domainError = 'Please input a valid email address.';
          return;
        }
      }
    }

    // Move to confirmation
    this.enteredEmail = email;
    this.currentState = 'confirm';
  }

  onConfirmYes(): void {
    this.dialogRef.close({ action: 'yes', email: this.enteredEmail });
  }

  onConfirmEdit(): void {
    this.currentState = 'emailInput';
    this.domainError = '';
  }

  onBackToInitial(): void {
    this.currentState = 'initial';
    this.emailControl.reset();
    this.domainError = '';
  }
}
